import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { IonIcon } from '@ionic/angular/standalone';

import { addIcons } from 'ionicons';
import { search, personSharp, send, informationCircle, arrowBackCircleOutline, refresh, close, arrowDownCircle, copy, personCircle, arrowForwardOutline, arrowForward, arrowUpCircleSharp, caretUpCircle, document, closeCircle, logOut, arrowBackCircleSharp, lockClosed, person, eye, eyeOff } from 'ionicons/icons';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';

declare var Gradient: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, CommonModule, FormsModule],
})
export class AppComponent {
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    @Inject(DOCUMENT) private documentEl: Document
  )
     {
    addIcons({
      arrowUpCircleSharp,
      arrowBackCircleSharp,
      arrowBackCircleOutline,
      lockClosed,
      person,
      eye,
      eyeOff,
      logOut,
      document,
      closeCircle,
      caretUpCircle,
      search,
      arrowForwardOutline,
      arrowForward,
      personSharp,
      personCircle,
      copy,
      close,
      arrowDownCircle,
      refresh,
      send,
      informationCircle
    });
  }

  public_key: string | null = null;
  ngOnInit() {
    const url = new URL(window.location.href);
    const company_id = url.searchParams.get('company_id');
    this.public_key = url.searchParams.get('public_key');
    localStorage.setItem('public_key', this.public_key || '');

    const chatId = url.searchParams.get('chatId');
    localStorage.setItem('company_id', company_id || '');

    if (!chatId) {
      localStorage.removeItem('chatId');
    }
    // if (this.authService.isAuthenticated()){
    //   this.apiService.getAgents().subscribe((res: any) => {})
    // }
  }
  @ViewChild('gradientCanvas') canvasRef!: ElementRef;
  

  chatId: string | null = null // Retrieve chatId from localStorage

  get isChatIdPresent(): boolean {
      return !!this.chatId;
  }

  ngAfterViewInit() {
    this.chatId = localStorage.getItem('chatId');
    if (this.chatId){
      // this.renderer.setStyle(this.documentEl.body, '--ion-background-color', '#fff');
      this.documentEl.body.style.setProperty('--ion-background-color', '#fff');
      return
    }


    const canvas = this.canvasRef.nativeElement;
    console.log('Canvas:', canvas);
    if (canvas) {
      try {
        const gradient = new Gradient();

        if (this.public_key === 'd774c0df0c') {
          console.log('Public key is d774c0df0c, applying Alsace gradient');
          this.documentEl.documentElement.style.setProperty('--gradient-color-1', '#e28245');
          this.documentEl.documentElement.style.setProperty('--gradient-color-2', '#efca84');
          this.documentEl.documentElement.style.setProperty('--gradient-color-3', '#adc6c6');
          this.documentEl.documentElement.style.setProperty('--gradient-color-4', '#adc6c6');
        }

        gradient.initGradient('#gradient-canvas');
      } catch (err) {
        console.error('Erreur d’initialisation du gradient :', err);
      }
    } else {
      console.error('Canvas non trouvé');
    }
  }
}
